export default __webpack_public_path__ + "static/media/18.e9fdb402.jpg";